import { appConfig } from "@shared/utils/appConfig";
import {
  domainGroupEnum,
  getCurrentDomainGroup,
  DomainGroup,
} from "@shared/utils/domain-group";

const API_ROOT_URL_BY_DOMAIN_GROUP: Record<DomainGroup, string> = {
  [domainGroupEnum.SIDEKICK]: appConfig.SIDEKICK_API_URL,
  [domainGroupEnum.RADAR]: appConfig.RADAR_BRAND_API_URL,
};

export const getApiRootUrl = (): string =>
  API_ROOT_URL_BY_DOMAIN_GROUP[getCurrentDomainGroup()];
